import { useCallback, useState } from 'react';
import CopyLink from '@/icons/components/CopyLink';
import styles from './styles.module.css';
import { Facebook, Twitter, Whatssap } from '@/icons/index';

const SocialLinks = (props) => {

    const {
        url,
        containerClass
    } = props;

    const [copied, setCopied] = useState(false);
    const [showTooltip, setShowTooltip] = useState(true);

    const handleCopyLink = useCallback(() => {
        if (typeof window === 'undefined') return;

        const currentUrl = window.location.href;

        if (navigator.clipboard && window.isSecureContext) {
            navigator.clipboard.writeText(currentUrl);
        } else {
            const textArea = document.createElement('textarea');
            textArea.value = currentUrl;
            textArea.style.position = 'fixed';
            textArea.style.left = '-9999px';
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            document.execCommand('copy');
            document.body.removeChild(textArea);
        }

        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    }, []);

    return (
        <div className={`${styles['container-social-icons-top']} ${containerClass || ''}`}>

            {/* Facebook */}
            <a
                href={`https://www.facebook.com/sharer.php?u=https://www.ellitoral.com${url}`}
                target="_blank"
                rel='noreferrer noopener'
                aria-label="Compartir la nota en Facebook"
                title="Compartir la nota en Facebook"
            >
                <div className={styles["icon"]}>
                    <Facebook className={`${styles["internal-icon"]} ${styles["facebook-internal-icon"]}`} />
                </div>
            </a>

            {/* Twitter / X */}
            <a
                href={`http://twitter.com/share?url=https://www.ellitoral.com${url}`}
                target="_blank"
                rel='noreferrer noopener'
                aria-label="Compartir la nota en X"
                title="Compartir la nota en X"
            >
                <div className={styles["icon"]}>
                    <Twitter className={`${styles["internal-icon"]} ${styles["twitter-internal-icon"]}`} />
                </div>
            </a>

            {/* WhatsApp */}
            <a
                href={`https://api.whatsapp.com/send?text=Accede%20a%20esta%20noticia%20de%20El%20Litoral:%20https://www.ellitoral.com${url}%3Futm_medium%3Dwhatsapp%20-%20Envianos%20tu%20noticia%20a:%20%2B5493426305344`}
                target="_blank"
                rel='noreferrer noopener'
                aria-label="Compartir la nota en WhatsApp"
                title="Compartir la nota en WhatsApp"
            >
                <div className={styles["icon"]}>
                    <Whatssap className={styles["internal-icon"]} />
                </div>
            </a>

            {/* Copiar Link */}
            <a
                onClick={handleCopyLink}
                className={styles["icon"]}
                aria-label="Copiar Link de la Nota"
                title="Copiar Link de la Nota"
            >
                <CopyLink className={styles["internal-icon"]} />
            </a>

            {/* Toast copiado */}
            {copied && (
                <div className={styles.copyToast} aria-live="polite">
                    Link copiado al portapapeles
                </div>
            )}

            {/* Follow Google */}
            <a
                href={`https://www.google.com/preferences/source?q=ellitoral.com`}
                target="_blank"
                rel='noreferrer noopener'
                aria-label="Seguir a EL LITORAL en Google"
                title="Seguir a EL LITORAL en Google"
            >
                <div className={styles["agregar-el"]}>
                    + Agregar El Litoral en

                    <svg
                        width="18px"
                        height="18px"
                        viewBox="-3 0 262 262"
                        xmlns="http://www.w3.org/2000/svg"
                        preserveAspectRatio="xMidYMid"
                    >
                        <path
                            d="M255.878 133.451c0-10.734-.871-18.567-2.756-26.69H130.55v48.448h71.947c-1.45 12.04-9.283 30.172-26.69 42.356l-.244 1.622 38.755 30.023 2.685.268c24.659-22.774 38.875-56.282 38.875-96.027"
                            fill="#4285F4"
                        />

                        <path
                            d="M130.55 261.1c35.248 0 64.839-11.605 86.453-31.622l-41.196-31.913c-11.024 7.688-25.82 13.055-45.257 13.055-34.523 0-63.824-22.773-74.269-54.25l-1.531.13-40.298 31.187-.527 1.465C35.393 231.798 79.49 261.1 130.55 261.1"
                            fill="#34A853"
                        />

                        <path
                            d="M56.281 156.37c-2.756-8.123-4.351-16.827-4.351-25.82 0-8.994 1.595-17.697 4.206-25.82l-.073-1.73L15.26 71.312l-1.335.635C5.077 89.644 0 109.517 0 130.55s5.077 40.905 13.925 58.602l42.356-32.782"
                            fill="#FBBC05"
                        />

                        <path
                            d="M130.55 50.479c24.514 0 41.05 10.589 50.479 19.438l36.844-35.974C195.245 12.91 165.798 0 130.55 0 79.49 0 35.393 29.301 13.925 71.947l42.211 32.783c10.59-31.477 39.891-54.251 74.414-54.251"
                            fill="#EB4335"
                        />
                    </svg>
                </div>
            </a>
           
        </div>
    );
};

export default SocialLinks;